import { Link, useNavigate } from "react-router-dom";
import { faUser } from "@fortawesome/free-regular-svg-icons";
import { Button, Dropdown, DropdownMenu, DropdownMenuElement, Icon } from "@webtypen/react-components";
import { AuthHelper, ConfirmHelper } from "../helpers";

export const LayoutUsermenu = () => {
    const navigate = useNavigate();

    const logout = async () => {
        const status = await ConfirmHelper.confirm("Wirklich ausloggen?", { confirmAttributes: { color: "danger" } });
        if (!status) {
            return;
        }
        AuthHelper.logout();
        navigate("/");
        window.location.reload();
    };

    return (
        <Dropdown
            right
            trigger={
                <Button type="button" dark>
                    <Icon icon={faUser} />
                </Button>
            }
        >
            <DropdownMenu style={{ width: 200 }}>
                <DropdownMenuElement>
                    <Link to="/change-pw">Passwort ändern</Link>
                </DropdownMenuElement>
                <DropdownMenuElement>
                    <button
                        type="button"
                        onClick={logout}
                        style={{ fontSize: 14, fontFamily: "Montserrat, sans-serif" }}
                    >
                        Ausloggen
                    </button>
                </DropdownMenuElement>
            </DropdownMenu>
        </Dropdown>
    );
};
